/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { DocumentServiceProxy } from "../../documentServiceProxy.js";
import { DocumentStorageServiceCompressionAdapter as DocumentStorageServiceSummaryBlobCompressionAdapter } from "./summaryblob/index.js";
export class DocumentServiceCompressionAdapter extends DocumentServiceProxy {
    constructor(service, _config) {
        super(service);
        this._config = _config;
        // Back-compat Old driver
        if (service.on !== undefined) {
            service.on("metadataUpdate", (metadata) => this.emit("metadataUpdate", metadata));
        }
    }
    async connectToStorage() {
        const storage = await super.connectToStorage();
        const wrapped = new DocumentStorageServiceSummaryBlobCompressionAdapter(storage, this._config);
        await wrapped.getSnapshotTree();
        return wrapped;
    }
}
//# sourceMappingURL=documentServiceCompressionAdapter.js.map